import * as React from 'react';
import { SVGProps } from 'react';

const IconPhotoSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm1.2 13.733a1 1 0 0 0-.2.6V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1.697a1 1 0 0 0-.168-.555L17 12l-4 6-3-4-2.8 3.733Z"
    />
  </svg>
);
export default IconPhotoSizeL;
